module.exports = __webpack_public_path__ + "static/media/rotate_screen.9ca9fe72.png";